import { setList, createUpdateItem, setSelected, removeItem } from './serviceTypeSlice';
import api, { normalize } from 'api';

export const getList = (params) => async dispatch => {
  try{
    const response = await api.get('site/service_types', params)
    
    const service_types = normalize(response).service_types || {}
    dispatch(setList(service_types))
  }catch(e){
    console.log(e)
  }
} 

export const create = (payload, callback) => async dispatch => {
  try{

    const response = await api.post('site/service_types', payload)
    const service_types = normalize(response).service_types || {}
    await dispatch(createUpdateItem(service_types))

    if(callback)
      await callback(service_types)
  }catch(e){
    console.log(e)
  }
} 

export const update = (id, payload, callback) => async dispatch => {
  
  try{
    const response = await api.put(`site/service_types/${id}`, payload)
    const service_types = normalize(response).service_types || {}
    await dispatch(createUpdateItem(service_types))

    if(callback)
      await callback(response) 
  }catch(e){
    console.log(e)
  }
} 

export const show = setSelected

export const remove = (id, callback) => async dispatch => {
  
  try{
    
    const response = await api.delete(`site/service_types/${id}`)
    
    await dispatch(removeItem(id))

    if(callback)
      await callback(response) 
  }catch(e){
    console.log(e)
  }
} 
